/*
eslint-disable
  no-underscore-dangle,
  class-methods-use-this,
  no-bitwise,
  no-use-before-define
*/

class Atom {
  parent;

  depth;

  _offset;

  type;

  length;

  children = [];

  raw;

  hasChildren = false;

  constructor(data, type, length, offset, parent) {
    this.parent = parent;
    this._offset = offset;
    this.depth = parent ? parent.depth + 1 : 0;
    this.raw = data;
    this.length = length;
    this.type = type;

    if (this.canTraverseChildren) {
      let innerOffset = 8;
      let child;

      while (innerOffset + 8 <= data.length) {
        child = Atom.parse(data, innerOffset, this);
        this.children.push(child);
        innerOffset += child.length;
      }
    }
  }

  get canTraverseChildren() {
    return false;
  }

  static parse(arr, offset = 0, parent = undefined) {
    if (offset + 8 > arr.length) {
      return undefined;
    }
    let atomLength =
      (arr[offset] << 24) + (arr[offset + 1] << 16) + (arr[offset + 2] << 8) + arr[offset + 3];

    // Check for extended (64 bit) size.
    if (atomLength === 1) {
      // This will support up to 281TB (2^48) while staying within the 53 bit JS limit.
      atomLength =
        (arr[offset + 10] << 40) +
        (arr[offset + 11] << 32) +
        (arr[offset + 12] << 24) +
        (arr[offset + 13] << 16) +
        (arr[offset + 14] << 8) +
        arr[offset + 15];
    }

    const atomType =
      String.fromCharCode(arr[offset + 4]) +
      String.fromCharCode(arr[offset + 5]) +
      String.fromCharCode(arr[offset + 6]) +
      String.fromCharCode(arr[offset + 7]);

    if (knownTypes[atomType] !== undefined) {
      return new knownTypes[atomType](
        arr.subarray(offset, offset + atomLength),
        atomType,
        atomLength,
        offset,
        parent,
      );
    }
    return new Atom(
      arr.subarray(offset, offset + atomLength),
      atomType,
      atomLength,
      offset,
      parent,
    );
  }

  get(atomType) {
    return this.children.filter((child) => child.type === atomType)[0];
  }

  getAll(atomType) {
    const matchingChildren = this.children.filter((child) => child.type === atomType);
    return matchingChildren;
  }

  get offset() {
    return this._offset + (this.parent ? this.parent.offset : 0);
  }

  set offset(value) {
    this._offset = value;
  }

  toString() {
    return `${new Array(this.depth + 1).join('  ')}${this.type}\n${this.children
      .map((child) => child.toString())
      .join('')}`;
  }
}

class Stbl extends Atom {
  get canTraverseChildren() {
    return true;
  }

  get stco() {
    return this.get('stco');
  }

  get co64() {
    return this.get('co64');
  }
}

class Minf extends Atom {
  get canTraverseChildren() {
    return true;
  }

  get stbl() {
    return this.get('stbl');
  }
}

class Mdia extends Atom {
  get canTraverseChildren() {
    return true;
  }

  get minf() {
    return this.get('minf');
  }
}

class Trak extends Atom {
  get canTraverseChildren() {
    return true;
  }

  get mdia() {
    return this.get('mdia');
  }
}

class Moov extends Atom {
  get canTraverseChildren() {
    return true;
  }

  get traks() {
    return this.getAll('trak');
  }
}

const knownTypes = {
  mdia: Mdia,
  minf: Minf,
  moov: Moov,
  stbl: Stbl,
  trak: Trak,
};

export { Atom, Moov, Trak, Mdia, Minf, Stbl };
